import React from "react";
import INTERCOM_ARTICLES from "../../constants/intercomArticles";
import SubmissionTranslator from "../utils/SubmissionTranslator";

export default function SubmissionSummaryChart({ submissionType, claimsData }) {
  const translator = new SubmissionTranslator(submissionType);

  function renderClaimSummaryRows() {
    return claimsData.issues.map((status) => {
      const info = {
        title: translator.getIssueTitle(status.name),
        description: translator.getIssueDescription(status.name),
      };
      return (
        <tr key={status.name}>
          <td>{info.title}</td>
          <td className="t--subtitle">{info.description}</td>
          <td>{status.count}</td>
          <td>{`${status.percent}%`}</td>
        </tr>
      );
    });
  }

  return (
    <div className="flex gap--16">
      <div className="flex flex-column flex-shrink-0 gap--8" style={{ width: 180 }}>
        <div className="stat_card__container">
          <div className="stat_card__header">Conforming Claims</div>
          <div className="stat_card__body">
            <div className="stat_card__body__value">{claimsData.conforming_count}</div>
          </div>
        </div>
        <div className="stat_card__container">
          <div className="stat_card__header">Non-Conforming Claims</div>
          <div className="stat_card__body">
            <div className="stat_card__body__value">{claimsData.non_conforming_count}</div>
          </div>
        </div>
      </div>
      <div className="flex flex-column align-items-start pd--20 border br--8 pa--20 flex-grow-1">
        <div className="flex justify-content-between align-items-center align-self-stretch mb--10">
          <div>
            <div className="t--500 mb--4 t--left">Non-Conforming Claim Issue Summary</div>
            <div className="t--xsm t--subtitle t--left">
              *Each individual claim may have more than one issue.
            </div>
          </div>
          <a href={INTERCOM_ARTICLES.HOW_TO_REVIEW_CLAIMS_DATA} target="_blank">
            <div className="flex align-items-center gap--8">
              <div className="submission_summary__learn_issues_icon">?</div>
              <div className="submission_summary__learn_issues_text">Learn more about issues</div>
            </div>
          </a>
        </div>
        {claimsData.issues.length === 0 ? (
          <div className="submission_summary__empty">No issues</div>
        ) : (
          <table className="submission_summary__table">
            <thead>
              <tr className="sm">
                <th>Issue Type</th>
                <th></th>
                <th>Count</th>
                <th>% of Total Claims</th>
              </tr>
            </thead>
            <tbody>{renderClaimSummaryRows()}</tbody>
          </table>
        )}
      </div>
    </div>
  );
}
